<template>
	<div class="page" data-name="cgl-dashboard">
    <f7-navbar>
			<f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <div class="title">
        대시보드
      </div>
			<f7-nav-right>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <div class="page-content" style="background-color:#efeff4">
      <div class="card card-outline">
        <div class="card-header">                
          <div class="item-title">학습 요약</div>
          <div class="item-after">
						<a href="#" class="item-link" v-on:click="studyDetail();">
							<span class="badge color-orange">상세보기</span>
						</a>
					</div>               
        </div>
        <div class="card-content">
          <div class="row">
            <div class="thin-border-box top-box col-50 xsmall-50 small-50 medium-50 large-50 xlarge-auto">
              <p><i class="f7-icons">person_fill</i><span>학생수</span></p>
              <p><span class="text-color-primary">163</span></p>
              <p><span>지난달 대비</span> <span>▼ 2%</span></p>
            </div>
            <div class="thin-border-box top-box col-50 xsmall-50 small-50 medium-50 large-50 xlarge-auto">
              <p><i class="f7-icons">chart_bar_square</i><span>이번달 퇴원학생</span></p>
              <p><span class="text-color-red">38</span></p>
              <p><span>지난달 대비</span> <span>▲ 2%</span></p>
            </div>       
          </div>
					<div class="row">
						<div class="thin-border-box top-box col-50 xsmall-50 small-50 medium-50 large-50 xlarge-auto">
							<p><i class="f7-icons">chart_bar_square</i><span>금일 학습자수</span></p>
							<p><span class="text-color-primary">38</span></p>
							<p><span>어제 대비</span> <span>▼ 2%</span></p>
						</div>
      			<div class="thin-border-box top-box col-50 xsmall-50 small-50 medium-50 large-50 xlarge-auto">
							<p><i class="f7-icons">person_fill</i><span>금일 학습총량</span></p>
							<p><span class="text-color-primary">62</span></p>
							<p><span>어제 대비</span> <span>▼ 2%</span></p>
						</div>
					</div>
          <div class="row">
            <div class="thin-border-box top-box col-50 xsmall-50 small-50 medium-50 large-50 xlarge-auto">
              <p><i class="f7-icons">chart_bar_square</i><span>이번주 학습자수</span></p>
              <p><span class="text-color-primary">112</span></p>
              <p><span>지난주 대비</span> <span>▼ 2%</span></p>
            </div>
            <div class="thin-border-box top-box col-50 xsmall-50 small-50 medium-50 large-50 xlarge-auto">
              <p><i class="f7-icons">person_fill</i><span>이번주 미학습자수</span></p>
              <p><span class="text-color-red">18</span></p>
              <p><span>지난주 대비</span> <span>▲ 2%</span></p>
            </div>
          </div>
				
        </div>
      </div>   
      <div class="card card-outline">
        <div class="card-header">     
          <div class="item-title">이번달 입금 하실 금액 </div>
          <div class="item-after">
						<a href="#" class="item-link" v-on:click="payDetail();">
							<span class="badge color-orange">상세보기</span>
						</a>
					</div>             
        </div>
        <div class="card-content">
          <div class="row">             
            <div class="thin-border-box top-box col-100 xsmall-100 small-100 medium-100 large-100 xlarge-auto">
              <p><i class="f7-icons">chart_bar_square</i><span>10월 입금 금액</span></p>
              <p><span class="text-color-red">3,000,00원</span></p>
              <p><span>지난달 대비</span> <span>▲ 2%</span></p>
            </div>       
          </div>        
        </div>
      </div> 

    </div>
	</div>
</template>

<script>
import MODULE from '../../../js/common/module';
import Vue from 'vue';
import PAGES from '../../../js/pages';
import CONST from '../../../js/common/constant';
import API from '../../../js/common/api';
import AUTH from '../../../js/common/auth';
import Chart from 'chart.js';

export default {
  data() {
    return {

    }
  },
  mounted() {
		const _this = this;	  
		
  },
  methods: {
		studyDetail() {
			const _this = this;

			var url = PAGES.SUB_CGL_STUDY_DETAIL;
			var param = undefined;

			PAGES.popPage(url, param);
		},
		payDetail() {
			const _this = this;
			var url = PAGES.SUB_CGL_PAY_DETAIL;
			var param = undefined;

			PAGES.popPage(url, param);
		}
  }
}

</script>